__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@cisco-sbg/cspe-caduceus";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@okta/okta-auth-js", "7.14.0", () => (__webpack_require__.e(5648).then(() => (() => (__webpack_require__(65648))))));
			register("@okta/okta-react", "6.10.0", () => (Promise.all([__webpack_require__.e(9673), __webpack_require__.e(318), __webpack_require__.e(6793), __webpack_require__.e(6222)]).then(() => (() => (__webpack_require__(69673))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(2483), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(22483))))));
			register("react-router-dom", "6.30.3", () => (Promise.all([__webpack_require__.e(4194), __webpack_require__.e(318), __webpack_require__.e(6672)]).then(() => (() => (__webpack_require__(84194))))));
			register("react", "16.14.0", () => (__webpack_require__.e(6493).then(() => (() => (__webpack_require__(36493))))));
			register("react", "16.14.0", () => (__webpack_require__.e(433).then(() => (() => (__webpack_require__(30433))))));
			register("react", "18.3.1", () => (__webpack_require__.e(7810).then(() => (() => (__webpack_require__(77810))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};